<template>
    <div :style="{ display: type === 'dropdown-item' ? 'block' : 'inline-block' }">
        <!-- Button -->
        <b-button v-if="type == 'button'" @click="openModal" :type="buttonType" :size="buttonSize" icon-right="paper-plane" :loading="isLoading || !customer" :disabled="!customer">
            {{ buttonText }}
        </b-button>

        <b-modal id="customer-mail" v-model="isModalActive" @close="close" :width="840" scroll="keep">
            <div class="card text-left" v-if="customer">
                <header class="modal-card-head"><p class="modal-card-title">E-mail versturen naar {{ customer?.firstname }} {{ customer?.lastname }}</p></header>

                <div class="modal-card-body">
                    <b-field label="Onderwerp" :type="getType(errors, 'subject', '')" :message="getError(errors, 'subject')">
                        <b-input v-model="subject" ref="subjectInput"></b-input>
                    </b-field>

                    <b-field label="Bericht" :type="getType(errors, 'content', '')" :message="getError(errors, 'content')"></b-field>
                    <div style="border:1px solid #dbdbdb;border-radius:4px;">
                        <div v-html="emailIntro" class="intro-footer" style="font-size:13px;padding:10px 15px; background-color: #f5f5f5;"></div>

                        <QuillEditor
                            :theContent="content"
                            @contentChanged="onContentChanged"
                            :toolbar="[
                                ['bold', 'italic', 'underline', 'strike'],
                                ['blockquote'],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                [{ 'color': [] }],
                            ]"
                        />
                        <div v-html="emailFooter" class="intro-footer" style="font-size:13px;padding:10px 15px; background-color: #f5f5f5;"></div>
                    </div>
                </div>

                <footer class="modal-card-foot">
                    <b-button type="is-light" @click.prevent="isModalActive = false">Annuleren</b-button>

                    <b-button type="is-success" icon-right="paper-plane" @click.prevent="sendMail" :loading="isSending" :disabled="isSending">
                        Versturen
                    </b-button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import QuillEditor from '@/vue/QuillEditor';
import formvalidationMixin from '@/mixins/formvalidationMixin.js'

export default {
    name: 'CustomerMail',

    mixins: [formvalidationMixin],

    components: {
        QuillEditor
    },
    props: {
        type: {
            type: String,
            default: 'button'
        },
        customer: {
            type: Object,
            default: null
        },
        invoice: {
            type: [Number, String],
            default: null
        },
        contract: {
            type: [Number, String],
            default: null
        },
        buttonSize: {
            type: String,
            default: ''
        },
        buttonText: {
            type: String,
            default: 'Klant mailen'
        },
        buttonType: {
            type: String,
            default: 'is-primary'
        }
    },
    data() {
        return {
            isModalActive: false,
            isLoading: false,
            isSending: false,
            subject: '',
            content: '',
            emailIntro: '',
            emailFooter: '',
            errors: {}
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        openModal() {
            // Fetch intro & footer if not already loaded
            if(!this.emailIntro || !this.emailFooter) {
                this.fetchIntroFooter()
            }

            if (this.invoice) {
                this.subject = `Bericht over factuur #${this.invoice}`
            } else if (this.contract) {
                this.subject = `Bericht over contract #${this.contract}`
            }

            this.isModalActive = true
        },

        close() {
            this.isModalActive = false
            this.$emit('close')

            // Reset intro & footer if dropdown item since that can change
            if (this.type == 'dropdown-item') {
                this.emailIntro = ''
                this.emailFooter = ''
                this.subject = ''
                this.content = ''
            }
        },

        fetchIntroFooter() {
            this.isLoading = true

            axios.get(`/api/mail/intro-footer-text/${this.user.organisation}`, {
                params: {
                    customer: this.customer.id
                },
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(response => {
                this.emailIntro = response.data.intro
                this.emailFooter = response.data.footer
            }).catch(error => {
                this.showError('Kon de e-mail template niet laden.')
            }).finally(() => {
                this.isLoading = false
            })
        },

        onContentChanged(content) {
            this.content = content
        },

        sendMail() {
            this.errors = {}

            if (this.isSending || !this.customer) return

            this.isSending = true

            const payload = {
                type: 'specific_customer',
                sendDirect: true,
                customer: this.customer.id,
                organisation: this.user.organisation,
                subject: this.subject,
                content: this.content,
                invoice: this.invoice,
                contract: this.contract,
            }

            axios.post('/api/mail', payload, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then(() => {
                this.$buefy.toast.open({
                    message: 'E-mail succesvol verzonden!',
                    type: 'is-success'
                })
                this.isModalActive = false
                this.subject = ''
                this.content = ''
                this.$emit('mailSent')
                this.close()
            }).catch(error => {
                this.errors = {...error.response.data.errors}

                let message = 'Er is een fout opgetreden bij het verzenden van de e-mail.'
                if (error.response && error.response.data && error.response.data.errors) {
                    message = Object.values(error.response.data.errors).flat().join('<br>')
                }
                this.showError(message)
            }).finally(() => {
                this.isSending = false
            })
        },

        showError(message) {
             this.$buefy.toast.open({
                duration: 5000,
                message: message,
                type: 'is-danger'
            })
        }
    },
    watch: {
        customer(newVal) {
            if (newVal && this.type == 'dropdown-item') {
                this.openModal()
            }
        },
        isModalActive(newVal) {
            if (!newVal && this.type == 'dropdown-item') {

            }
        }
    }
}
</script>
